import { OfficerManagementRoutes } from './pages/officer-management/officer-management.routes';
import { PoiManagementRoutes } from './pages/poi/poi.routes';
import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { CommonOutletsComponent } from './outlets/common-outlets/common-outlets.component';
import { UnauthenOutletsComponent } from './outlets/unauthen-outlets/unauthen-outlets.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { EServiceComponent } from './pages/e-service/e-service.component';
import { ShopNTravelComponent } from './pages/e-service/shop-n-travel/shop-n-travel.component';
import { HomeComponent } from './pages/home/home.component';
import { MembershipListComponent } from './pages/membership/membership-list/membership-list.component';
import { SandboxComponent } from './pages/sandbox/sandbox.component';
import { PoiComponent } from './pages/poi/poi.component';

export const routes: Routes = [
  {
    path: '',
    component: CommonOutletsComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: HomeComponent },
      { path: 'calendar', component: CalendarComponent },
      { path: 'e-service', component: EServiceComponent },
      {
        path: 'membership',
        loadChildren: () =>
          import('./pages/membership/membership.routes').then(
            (r) => r.MemberShipRoutes,
          ),
      },
      {
        path: 'act-officer',
        loadChildren: () =>
          import('./pages/others/act-officer.routes').then(
            (r) => r.ActOfficerRoutes,
          ),
      },
      {
        path: 'act-farmer',
        loadChildren: () =>
          import('./pages/others/act-farmer.routes').then(
            (r) => r.ActFarmerRoutes,
          ),
      },
      {
        path: 'manage-farmer-type-inst',
        loadChildren: () =>
          import('./pages/system-settings/manage-farmer-type-inst.routes').then(
            (r) => r.ManageFarmerTypeInstComponentFarmerRoutes,
          ),
      },
      { path: 'agri', component: MembershipListComponent },
      { path: 'shop-and-travel', component: ShopNTravelComponent },
      {
        path: 'other-systems',
        loadChildren: () =>
          import('./pages/other-systems/other-systems.routes').then(
            (r) => r.OtherSystemsRoutes,
          ),
      },
      {
        path: 'region',
        loadChildren: () =>
          import('./pages/region/region.routes').then((r) => r.REGION_ROUTES),
      },
      {
        path: 'wish-management',
        loadChildren: () =>
          import('./pages/wish-management/wish-management.routes').then(
            (r) => r.WISH_MANAGEMENT_ROUTES,
          ),
      },
      {
        path: 'user-role-management',
        loadChildren: () =>
          import('./pages/user-role-management/user-role-management.routes').then(
            (r) => r.USER_ROLE_MANAGEMENT_ROUTES,
          ),
      },
      {
        path: 'officer-role-management',
        loadChildren: () =>
          import('./pages/officer-role-management/officer-role-management.routes').then(
            (r) => r.OFFICER_ROLE_MANAGEMENT_ROUTES,
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/profile/profile.routes').then((r) => r.ProfileRoutes),
      },

      {
        path: 'farmer-status-management',
        loadChildren: () =>
          import('./pages/farmer-status-management/farmer-status-management.routes').then(
            (r) => r.FarmerStatusManagementRoutes,
          ),
      },

      {
        path: 'poi-management',
        loadChildren: () =>
          import('./pages/poi/poi.routes').then((r) => r.PoiManagementRoutes),
      },

      {
        path: 'officer-management',
        loadChildren: () =>
          import('./pages/officer-management/officer-management.routes').then(
            (r) => r.OfficerManagementRoutes,
          ),
      },

      {
        path: 'user-management',
        loadChildren: () =>
          import('./pages/user-management/user-management.routes').then(
            (r) => r.UserManagementRoutes,
          ),
      },
    ],
  },
  {
    path: 'sandbox',
    component: CommonOutletsComponent,
    // component: MapsOutletsComponent,
    children: [{ path: '', component: SandboxComponent }],
  },
  {
    path: 'auth',
    component: UnauthenOutletsComponent,
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((r) => r.AuthRoutes),
  },
];
